import styled from "styled-components";
import {ProfileMessagesDefaultBox} from "./profile-messages.default.box";

export const ProfileMessagesCasino777Box = styled(ProfileMessagesDefaultBox)`
    padding: 0.5rem 0;
    background: ${({theme}) => theme.colors.brandSecondary };

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        background: transparent;
    }
`;
